<template>
  <div>
    <div v-if="editing">
      <div class="input-group mb-3">
        <input type="text" class="form-control" v-model="newProjectName" @blur="saveProject" v-on:keyup.enter="saveProject" placeholder='Project Name'>
        <div class="input-group-append">
          <button class="btn btn-primary" type="button" @click="saveProject">Save</button>
        </div>
      </div>
    </div>
    <span v-else>
      <i class="material-icons pointer x-small-icon" data-toggle="dropdown">edit</i>
      <!-- <div class="dropdown-menu dropdown-menu-left">
        <a v-if="!this.project.archived_at" class="dropdown-item text-primary" href="#" @mousedown="focus">Edit</a>
        <a class="dropdown-item text-danger" href="#" data-toggle="modal" :data-target="'#archiveModal' + this.project.id">
          {{ actionName }} Project
        </a>
      </div> -->
      <div class="dropdown-menu dropdown-menu-left">
        <a class="dropdown-item" href="#" data-toggle="modal" :data-target="'#editModal' + this.project.id">Edit</a>
        <a v-if="!isArchived()" class="dropdown-item text-primary" href="#" data-toggle="modal" :data-target="'#moveModal' + this.project.id">Move to {{ $t("tags.plural") }}</a>
        <a v-if="isArchived()" class="pointer dropdown-item text-danger"  @click="unarchiveProject()">Unarchive {{ $t("projects.singular") }}</a>
        <a v-else class="dropdown-item text-danger" href="#" data-toggle="modal" :data-target="'#archiveModal' + project.id">Archive {{ $t("projects.singular") }}</a>
        <a v-if="isTrashed()" class="pointer dropdown-item text-danger"  @click="untrashProject()">Remove from Trash</a>
        <a v-else class="dropdown-item text-danger" href="#" data-toggle="modal" :data-target="'#trashModal' + this.project.id">Trash {{ $t("projects.singular") }}</a>
      </div>
      <div class="modal fade" :id="'editModal' + project.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Update {{ $t("projects.singular") }}</h5>
          </div>
          <div class="modal-body">
            <div>
             <div class="form-group row align-items-center">
              <div class="col">
                <input v-model="project.name" placeholder="Project Name" class="form-control">
              </div>
            </div>

              <div class="form-group row align-items-center">
                <div class="col">
                  <label for="project_area_id">{{ $t("categories.singular") }}</label>
                  <select name="project.project_area_id" v-model="project.project_area_id" class="form-control">
                    <option v-for="project_area in project_areas" :value="project_area.id">
                      {{ project_area.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="updateProject(project)">Save</button>
          </div>
        </div>
      </div>
    </div>      
      <div class="modal fade" :id="'archiveModal' + this.project.id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Are you sure you want to {{ actionName.toLowerCase() }} this {{ $t("projects.singular").toLowerCase() }}?</h5>
              </div>
              <div class="modal-body">
                <div> Are you sure you want to {{ actionName.toLowerCase() }}
                  <em>
                    {{this.project.name}}
                  </em>
                  ?
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button v-if="this.project.archived_at" type="button" class="btn btn-primary" @click="unarchiveProject()">{{ actionName }} Project</button>
                <button v-else type="button" class="btn btn-primary" @click="archiveProject()">{{ actionName }} {{ $t("projects.singular") }}</button>
              </div>
            </div>
          </div>
      </div>
      <div class="modal fade" :id="'trashModal' + this.project.id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Are you sure you want to {{ trashActionName.toLowerCase() }} this {{ $t("projects.singular").toLowerCase() }}?</h5>
              </div>
              <div class="modal-body">
                <div> Are you sure you want to {{ trashActionName.toLowerCase() }}
                  <em>
                    {{this.project.name}}
                  </em>
                  ?
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button v-if="this.project.archived_at" type="button" class="btn btn-primary" @click="unarchiveTrash()">{{ trashActionName }} {{ $t("projects.singular") }}</button>
                <button v-else type="button" class="btn btn-primary" @click="trashProject()">{{ trashActionName }} {{ $t("projects.singular") }}</button>
              </div>
            </div>
          </div>
      </div>
      <div class="modal fade" :id="'moveModal' + this.project.id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Are you sure you want to move this {{ $t("projects.singular").toLowerCase() }}?</h5>
              </div>
              <div class="modal-body">
                <div> Are you sure you want to move
                  <em>
                    {{this.project.name}}
                  </em>
                  to {{ $t("tags.plural") }}?
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" @click="moveProjectToTags()">Move to {{ $t("tags.plural") }}</button>
              </div>
            </div>
          </div>
      </div>      
      <router-link v-if="!project.starred" :to="{ name: 'project', params: { id: project.id } }" class="text-secondary">
        <span>{{project.name}} <i v-if="project.deleted" class="material-icons x-small-icon">delete</i></span>
      </router-link> 
    </span>
  </div>
</template>

<script>
import api from "api";

export default {
  components: {
  },
  props: {
    project: Object
    },
  data() {
    return {
      editing: false,
      newProjectName: this.project.name
    };
  },
  computed: {
    archived_at: function() {
      return new Date()
    },
    actionName: function () {
      return this.project.discarded ? 'Unarchive' : 'Archive'
    },
    trashActionName: function () {
      return this.project.deleted ? 'Untrash' : 'Trash'
    }, 
    project_areas: {
      get() {
        return this.$store.state.project_areas
      }
    },     
  },
  created() {
   this.originalProjectName = this.projectName
  },
  methods: {
    titleContent(){
      if(this.containerExpanded){
        return this.titleText
      } else {
        return this.titleText.length > 75 ? `${this.titleText.substring(0, 75)}...` : this.titleText;
      }
    },
    isArchived(){
      return this.project.discarded
    },
    isTrashed(){
      return this.project.deleted
    },    
    saveProject(){
      this.editing = false;
      api.updateProject(this.project.id, { name: this.newProjectName}).then(response => {
      });
    },
    archiveProject() {
      this.editing = false;
      $('#archiveModal' + this.project.id).modal('hide')
      api.deleteProject(this.project.id).then(response => {
      });
    },
    unarchiveProject() {
      this.editing = false;
      $('#archiveModal' + this.project.id).modal('hide')      
      api.undeleteProject(this.project.id).then(response => {
      });
    },
    trashProject() {
      this.editing = false;
      $('#trashModal' + this.project.id).modal('hide')
      api.trashProject(this.project.id).then(response => {
      });
    },
    untrashProject() {
      this.editing = false;
      $('#trashModal' + this.project.id).modal('hide')
      api.untrashProject(this.project.id).then(response => {
      });
    },
    updateProject(project) {
      $('#editModal' + project.id).modal('hide')
      api.updateProject(project.id, { name: this.project.name, project_area_id: this.project.project_area_id }).then(response => {
      });
    },    
    blur(event){
      this.saveTitle()
    },
    focus(event){
      this.editing = true;
    },
    tagSlug(){
      return this.tagName.replace(/ /g, '_');
    },
    moveProjectToTags(){
      $('#moveModal' + this.project.id).modal('hide');
      api.moveProjectToTags(this.project.id).then(response => {
        var tagId = response.data.id
        store.commit('addIdToSortedGroup', { name: 'tags', id: tagId })
        //store.commit('removeIdFromSortedGroup', { name: 'tags', id: tagId })
        this.$router.push({ name: 'all_tags' })
      });
    }
  }
}
</script>
